// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDjFhmKerTQYP5JamR3IHXz2ZjAyMYcsgo",
    authDomain: "gullycinema-9463c.firebaseapp.com",
    projectId: "gullycinema-9463c",
    storageBucket: "gullycinema-9463c.firebasestorage.app",
    messagingSenderId: "586333346683",
    appId: "1:586333346683:web:af9823ac2b6b90f92bbbde"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
const auth = getAuth(app);

// Set language for SMS templates
auth.languageCode = 'en';

// Auto-enable test mode on localhost to bypass reCAPTCHA during local development
// On production (real domain), reCAPTCHA works normally
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

if (isLocalhost) {
    // Bypass reCAPTCHA on localhost — configure test phone numbers in Firebase Console:
    // Firebase Console → Authentication → Settings → Phone numbers for testing
    // Add: +918106458788  →  OTP code: 123456  (or any 6-digit code you prefer)
    auth.settings.appVerificationDisabledForTesting = true;
    console.log('🔧 Firebase Test Mode: ENABLED (localhost detected)');
    console.log('📱 Use test phone +918106458788 with OTP 123456 from Firebase Console');
} else {
    auth.settings.appVerificationDisabledForTesting = false;
    console.log('🔧 Firebase Test Mode: DISABLED - Using real reCAPTCHA');
}

// Initialize Firestore
const db = getFirestore(app);

export { app, auth, db };
